import { render, staticRenderFns } from "./ProductsSetPopover.vue?vue&type=template&id=e95c8342&lang=pug&"
import script from "./ProductsSetPopover.vue?vue&type=script&lang=ts&"
export * from "./ProductsSetPopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports